import React, { useMemo } from 'react'
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import styles from './SelectFilter.module.css';

export const SelectFilter = ({ column }) => {
  const { filterValue, setFilter, preFilteredRows, id } = column;
  const dispatch = useDispatch();
  // console.log("filterValue: " + filterValue);
  // console.log("SelectFilter column: ", column)
  let filterName = column.id + "_filter";
  // console.log("status filter filterName: ", filterName);
  const columnValueFilter = useSelector(state => state[filterName]);
  // console.log("columnValueFilter: ", columnValueFilter);
  // console.log("preFilteredRows: ", preFilteredRows);

  useEffect(() => {
    if (columnValueFilter) {
      setFilter(columnValueFilter)
    }
  }, []);
  
  const setFilterStateHandler = (value) => {
    let finalValue = value;
    if (!isNaN(finalValue)) {
      finalValue = parseInt(finalValue, 10);
    }
    let actionType = column.id + "_filter"; // creates the name of the property that can be found in storeIndex.js
    // console.log("actionType: ", actionType);
    // console.log("actionType value: ", finalValue);

    dispatch({ type: actionType, filterValue: finalValue});
  }

  const onChangeHandler = (value) => {
    console.log("e.target.value = ", value);
    setFilter(value);
    setFilterStateHandler(value);
  }

  const options = useMemo(() => {
    const options = new Set();
    preFilteredRows.forEach(row => {
      options.add(row.values[id])
    })
    return [...options.values()]
  }, [id, preFilteredRows]);

  if (typeof options[0] === 'number') {
    options.sort((a,b) => a < b ? 1 : -1)
  }
  return (
    <span style={{width: "100%"}}>
      <select value={filterValue || columnValueFilter || ""} onChange={e => onChangeHandler(e.target.value)} className={styles.select}>
        <option value={""} className={styles.option}>All</option>
        {options.map((option, i) => {
          return (
          <option key={i} value={option}>
            {option}
          </option>
        )})}
      </select>
    </span>
  )
}

// Source: https://codesandbox.io/s/github/tannerlinsley/react-table/tree/master/examples/filtering?file=/src/App.js
// In the file, search for "SelectColumnFilter"
